import React, { useState } from 'react'

interface TabItem {
    label: string
    content: React.ReactNode
}

interface TabsProps {
    tabs: TabItem[]
    unmountInactiveTabs?: boolean
}

const Tabs: React.FC<TabsProps> = ({ tabs, unmountInactiveTabs = false }) => {
    const [activeIndex, setActiveIndex] = useState(0)

    return (
        <div className="w-full">
            {/* Tab Headers */}
            <div className="flex border-b">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        className={`px-4 py-2 -mb-px border-b-2 font-medium text-sm ${
                            activeIndex === index
                                ? 'border-ctxt-blue text-ctxt-blue'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                        onClick={() => setActiveIndex(index)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            {/* Tab Content */}
            <div className="mt-4">
                {unmountInactiveTabs ? (
                    // Only render the active tab; other tabs are unmounted
                    <div key={activeIndex}>{tabs[activeIndex].content}</div>
                ) : (
                    // Render all tabs; hide inactive ones but keep them mounted
                    tabs.map((tab, index) => (
                        <div
                            key={index}
                            className={activeIndex === index ? '' : 'hidden'}
                        >
                            {tab.content}
                        </div>
                    ))
                )}
            </div>
        </div>
    )
}

export default Tabs
